import { SET_SESSION_DATA, SET_IS_LOADING } from "../actions/sessionActions";
import SessionState from "../stateTypes/sessionState";

const initialState: SessionState = {
    sessionData: null,
    frontendSettings: null,
    appConfig: null,
    summaryData: null,
    applicationSettings: {
        dict: [],
    },
    isLoading: true,
    language: null,
    showPrice: false,
    showCancelButton: false,
    approximatePrices: false,
    dealerAccount: "",
};

const sessionReducer = (state: SessionState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_SESSION_DATA:
            return {
                ...state,
                sessionData: action.sessionData,
                frontendSettings: action.frontendSettings,
                appConfig: action.appConfig,
                summaryData: action.summaryData,
                applicationSettings: action.applicationSettings,
                language: action.language,
                showPrice: action.showPrice,
                showCancelButton: action.showCancelButton,
                approximatePrices: action.approximatePrices,
                dealerAccount: action.dealerAccount,
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};

export default sessionReducer;
